<template>
  <div>
    <g-form class="g-form">
      <div class="conteudo-pagina">
      <!-- <div class="titulo-fluxos">CARACTERÍSTICAS DO PRODUTO</div>
      <div class="subtitulo-fluxos">Confira e forneça as demais caracteristicas se necessário</div> -->

      <g-titulo-steps
    titulo="CARACTERÍSTICAS DO PRODUTO"
    subtitulo="Confira e forneça as demais características se necessário"
    :imagemEmpresa = imagemEmpresa
    />

        <div class="campos-que-podem-aparecer espacamento-fluxos" v-if="this.situacaoPedido == 0 || this.situacaoPedido == 2 || this.TipoFluxo == 0 || this.TipoFluxo ==2"  >
        <div>
          <div class="titulo-grupo-detalhes">Visual de Embalagem</div>
            <div class="containers-embalagem">
              <div class="check-embalagem">
                <div class="checkbox">
                  <PCheckBox :disabled="!this.CoresAtivas" class="mr-3" :binary="true" v-model="CaracteristicasPedido.VisualAmostra"></PCheckBox>
                  <label class="label">Amostra</label>
                </div>
              </div>
            <div class="check-embalagem campos">
                  <div class="checkbox">
                      <PCheckBox :disabled="!this.CoresAtivas" class="mr-3" :binary="true" v-model="CaracteristicasPedido.VisualTemOutros" @click="limparCampoOutrosVisual"></PCheckBox>
                      <label class="label">Outros</label>
                    </div>
                      <div class="campo-aparece">
                    <PInputText :disabled="!this.CoresAtivas" :class="`outros ${CaracteristicasPedido.VisualTemOutros ? false : 'invisivel'}`" v-model="CaracteristicasPedido.DescricaoVisualOutros"></PInputText>
                  </div>
                </div>
            <div class="check-embalagem campos">
                  <div class="checkbox">
                    <PCheckBox :disabled="!this.CoresAtivas" class="mr-3" :binary="true" v-model="CaracteristicasPedido.VisaulArquivo" @click="limparCampoArquivoDigital"></PCheckBox>
                    <label class="label">Arquivo Digital</label>
                  </div>
                  <div class="campo-aparece">
                  <div v-if="CaracteristicasPedido.VisaulArquivo">
                    <PInputText @input="PreencherArquivoNaObs" v-model="CaracteristicasPedido.VisualArquivoDescricao"></PInputText>
                  </div>
                  </div>
                </div>
                <div class="produto-container">
                <div class="d-flex">
                  <div class="checkbox">
                  <PCheckBox :disabled="!this.CoresAtivas" class="mr-3" :binary="true" v-model="CaracteristicasPedido.VisualEmpresa" @click="limparCampoEmpresaVisual"></PCheckBox>
                  <label class="label">Produto</label>
                </div>
              </div>
            </div>
                </div>
            <div v-if="CaracteristicasPedido.VisualEmpresa" class="campos-aparecem-empresa">
                    <PDropDown
                      v-model="UnidadeVisual"
                      :options="UnidadeArray"
                      optionLabel="nome"
                      optionValue="id"
                      placeholder="Selecione"
                      class="empresa"/>
                  <div class="Campos-Produto">
                  <div class="produto-container">
                    <label class=" label">Produto Nº</label>
                    <PDropDown
                      v-model="CaracteristicasPedido.VisualProdutoId"
                      :options="ProdutoOpcoesVisual"
                      @filter="buscarProdutosConformeProdutoVisual($event.value)"
                      @change="separaCodigoProdutoVisual"
                      optionLabel="labelProduto"
                      optionValue="produtoId"
                      placeholder="Selecione a Referência"
                      :filter="true"
                    >
                  <template #option="slotProps">
                    <produto-dropdown-item :produto="slotProps.option"></produto-dropdown-item>
                  </template>
                </PDropDown>
                  </div>
                  </div>
                </div>
            <div class="observacoes-container">
              <div class="obs-titulo">Observações</div>
              <PTextArea class="obs-campo" v-model="CaracteristicasPedido.DescricaoVisual" rows="4" cols="30" ></PTextArea>
            </div>
        </div>

        <div>
          <div class="titulo-grupo-detalhes">Impressão</div>
          <div class="containers-agrupa">
              <div class="check-impressao">
                <div class="checkbox">
                  <PCheckBox :disabled="!this.CoresAtivas" class="mr-3" @change="validacaoImpressao" :binary="true" v-model="this.CaracteristicasPedido.ImpressaoAmostra "></PCheckBox>
                  <label class="label">Amostra</label>
                </div>
              </div>
              <div class="check-impressao">
                <div class="checkbox">
                  <PCheckBox :disabled="!this.CoresAtivas" class="mr-3" @change="validacaoImpressao" :binary="true" v-model="this.CaracteristicasPedido.ImpressaoProvaDeCores  "></PCheckBox>
                  <label class="label">Prova de cores</label>
                </div>
              </div>
              <div class="check-impressao">
                <div class="checkbox">
                  <PCheckBox :disabled="!this.CoresAtivas" class="mr-3" @change="validacaoImpressao" :binary="true" v-model="this.CaracteristicasPedido.ImpressaoProvaDeCoresConfeccionar  "></PCheckBox>
                  <label  class="label">Prova de cores a confeccionar para aprovação</label>
                </div>
              </div>
              <div class="check-impressao campos">
                <div class="checkbox">
                    <PCheckBox :disabled="!this.CoresAtivas" class="mr-3" @change="validacaoImpressao" :binary="true" v-model="CaracteristicasPedido.ImpressaoPantone"  @click="limparCampoPantone"></PCheckBox>
                    <label class="label">Pantone Nº</label>
                  </div>
                  <div class="campo-aparece">
                  <PInputText :class="`numero-pantone ${CaracteristicasPedido.ImpressaoPantone ? false : 'invisivel'}`" v-model="this.CaracteristicasPedido.ImpressaoNumeroPantone"></PInputText>
                </div>
              </div>
              <div class="check-impressao campos">
                <div class="checkbox">
                    <PCheckBox :disabled="!this.CoresAtivas" class="mr-3" @change="validacaoImpressao" :binary="true" v-model="CaracteristicasPedido.ImpressaoTemOutros" @click="limparCampoOutrosImpressao"></PCheckBox>
                    <label class="label">Outros</label>
                  </div>
                  <div class="campo-aparece">
                  <PInputText :disabled="!this.CoresAtivas" :class="`outros ${CaracteristicasPedido.ImpressaoTemOutros ? false : 'invisivel' }`" v-model="CaracteristicasPedido.ImpressaoOutros"></PInputText>
                </div>
              </div>
            <div class="produto-container">
              <div class="d-flex">
                <div class="checkbox">
                <PCheckBox :disabled="!this.CoresAtivas" class="mr-3" @change="validacaoImpressao" :binary="true" v-model="CaracteristicasPedido.ImpressaoEmpresa" @click="limparCampoEmpresaImpressao" ></PCheckBox>
                <label class="label">Produto</label>
              </div>
            </div>
          </div>
          </div>

        <div v-if="CaracteristicasPedido.ImpressaoEmpresa " class="campos-aparecem-empresa">
              <PDropDown
                            v-model="UnidadeImpressao"
                            :options="UnidadeArray"
                            optionLabel="nome"
                            optionValue="id"
                            placeholder="Selecione"
                            class="empresa"/>
              <div class="Campos-Produto">
              <div class="produto-container">
                <label class=" label">Produto Nº</label>
                <PDropDown
                  v-model="CaracteristicasPedido.ImpressaoProdutoId"
                  :options="ProdutoOpcoesImpressao"
                  @filter="buscarProdutosConformeProdutoImpressao($event.value)"
                  @change="separaCodigoProdutoImpressao"
                  optionLabel="labelProduto"
                  optionValue="produtoId"
                  placeholder="Selecione a Referência"
                  :filter="true"
                >
              <template #option="slotProps">
                <produto-dropdown-item :produto="slotProps.option"></produto-dropdown-item>
              </template>
            </PDropDown>
              </div>
              </div>
        </div>

        <div class="observacoes-container">
          <div class="obs-titulo" >Observações</div>
          <PTextArea class="obs-campo" v-model="CaracteristicasPedido.ImpressaoDescricao" rows="4" cols="30" ></PTextArea>
        </div>
        </div>
        
        <div>
          <div v-if="seloFSC">
            <div class="titulo-grupo-detalhes">Selo FSC</div>
            <div class="fsc-infos-container">
              <div class="fsc-local-container">
                <div class="label">Local</div>
                <PTextArea class="obs-campo" v-model="CaracteristicasPedido.LocalFSC" rows="8" cols="50" ></PTextArea>
              </div>
              <div class="fsc-observacao-container">
                <div class="label">Observação</div>
                <PTextArea class="obs-campo" v-model="CaracteristicasPedido.ObservacaoFSC" rows="8" cols="50" ></PTextArea>
              </div>
            </div>
          </div>
        </div>


        <div v-if=" this.TipoFluxoIndependenteSequencia !== 1 ">
          <div class="titulo-grupo-detalhes">Faca / Sistema </div>
          <div class="containers-agrupa">
            <div class="check-faca-sistema">
              <div class="checkbox">
                <PCheckBox class="mr-3" :binary="true" v-model="CaracteristicasPedido.FacaSistemaAmostra" @Change ="ValidacaoAmostra" > </PCheckBox>
                <label class="label">Amostra</label>
              </div>
            </div>
            <div class="check-faca-sistema">
              <div class="checkbox">
                <PCheckBox class="mr-3" :binary="true" v-model="CaracteristicasPedido.FacaSistemaRiscoDeFaca" @Change="ValidacaoRisco"></PCheckBox>
                <label class="label">Risco</label>
              </div>
            </div>
            <div class="check-faca-sistema campos">
                <div class="checkbox">
                    <PCheckBox class="mr-3" :binary="true" v-model="CaracteristicasPedido.FacaSistemaTemOutros"  @Change="ValidacaoFacaSistemaTemOutros" @click="limparCampoOutrosSistema"></PCheckBox>
                    <label class="label">Outros</label>
                  </div>
                    <div class="campo-aparece">
                  <PInputText :class="`outros ${CaracteristicasPedido.FacaSistemaTemOutros ? false : 'invisivel'}`" v-model="CaracteristicasPedido.FacaSistemaOutros" ></PInputText>
                </div>
              </div>
          <div class="check-faca-sistema">
              <div class="checkbox">
                <PCheckBox class="mr-3" :binary="true" v-model="CaracteristicasPedido.FacaSistemaPlanta" @Change="ValidacaoPlanta" ></PCheckBox>
                <label class="label">Planta</label>
              </div>
            </div>
              <div class="check-faca-sistema campos">
                <div class="checkbox">
                  <PCheckBox class="mr-3" :binary="true" v-model="CaracteristicasPedido.FacaSistemaPrototipo" @Change ="ValidacaoPrototipo" @click="limparCampoPrototipoSistema"></PCheckBox>
                  <label class="label">Protótipo</label>
                </div>
                <div class="campo-aparece">
                <div v-if="CaracteristicasPedido.FacaSistemaPrototipo">
                  <PInputText @keypress="camponumero" maxlength="6" placeholder="Nº do Protótipo" v-model="CaracteristicasPedido.FacaSistemaPrototipoDescricao"></PInputText>
                </div>
                </div>
              </div>
              <div class="produto-container">
                <div class="checkbox">
                <PCheckBox class="mr-3" :binary="true" v-model="CaracteristicasPedido.FacaSistemaEmpresa" @click="limparCampoEmpresaSistema"></PCheckBox>
                <label class="label">Produto</label>
              </div>
          </div>
            </div>
                <div v-if="CaracteristicasPedido.FacaSistemaEmpresa " class="campos-aparecem-empresa">
                <PDropDown
                              v-model="UnidadeSistema"
                              :options="UnidadeArray"
                              optionLabel="nome"
                              optionValue="id"
                              placeholder="Selecione"
                              class="empresa"/>
                <div class="Campos-Produto">
                <div class="produto-container">
                  <label class=" label">Produto Nº</label>
                  <PDropDown
                    v-model="CaracteristicasPedido.FacaSistemaProdutoId"
                    :options="ProdutoOpcoesSistema"
                    @filter="buscarProdutosConformeProdutoSistema($event.value)"
                    @change="separaCodigoProdutoSistema"
                    optionLabel="labelProduto"
                    optionValue="produtoId"
                    placeholder="Selecione a Referência"
                    :filter="true"
                  >
                <template #option="slotProps">
                  <produto-dropdown-item :produto="slotProps.option"></produto-dropdown-item>
                </template>
              </PDropDown>
                </div>
                </div>
               </div>
          <div class="observacoes-container">
            <div class="obs-titulo">Observações</div>
            <PTextArea class="obs-campo" v-model="CaracteristicasPedido.FacaSistemaDescricao" rows="4" cols="30" ></PTextArea>
          </div>
        </div>


        <div v-if=" this.TipoFluxoIndependenteSequencia !== 1 ">
          <div class="titulo-grupo-detalhes">Faca / Medida</div>
          <div class="containers-agrupa">
            <div class="check-faca-medida">
            <div class="checkbox">
                <PCheckBox class="mr-3" :binary="true" v-model="CaracteristicasPedido.FacaMedidaAmostra" @Change ="ValidacaoAmostraMedida" ></PCheckBox>
                <label class="label">Amostra</label>
              </div>
            </div>
            <div class="check-faca-medida">
              <div class="checkbox">
                <PCheckBox class="mr-3" :binary="true" v-model="CaracteristicasPedido.FacaMedidaRiscoDeFaca" @Change ="ValidacaoRiscoMedida"></PCheckBox>
                <label class="label">Risco</label>
              </div>
            </div>
            <div class="check-faca-medida campos">
                <div class="checkbox">
                    <PCheckBox class="mr-3" :binary="true" v-model="CaracteristicasPedido.FacaMedidaTemOutros" @click="limparCampoOutrosMedida" @Change ="ValidacaoFacaMedidaTemOutros" ></PCheckBox>
                    <label class="label">Outros</label>
                  </div>
                  <div class="campo-aparece">
                  <PInputText :class="`outros ${CaracteristicasPedido.FacaMedidaTemOutros ? false : 'invisivel'}`" v-model="CaracteristicasPedido.FacaMedidaOutros"></PInputText>
                </div>
              </div>
            <div class="check-faca-medida">
              <div class="checkbox">
                <PCheckBox class="mr-3" :binary="true" v-model="CaracteristicasPedido.FacaMedidaPlanta" @Change ="ValidacaoPlantaMedida"></PCheckBox>
                <label class="label">Planta</label>
              </div>
            </div>
              <div class="check-faca-medida campos">
              <div class="checkbox">
                <PCheckBox class="mr-3" :binary="true" v-model="this.CaracteristicasPedido.FacaMedidaPrototipo" @Change ="ValidacaoPrototipoMedida" @click="limparCampoPrototipoMedida" ></PCheckBox>
                <label class="label">Protótipo</label>
              </div>
              <div class="campo-aparece">
              <div v-if="CaracteristicasPedido.FacaMedidaPrototipo">
                  <PInputText @keypress="camponumero" maxlength="6" placeholder="Nº do Protótipo" v-model="CaracteristicasPedido.FacaMedidaPrototipoDescricao"></PInputText>
                </div>
              </div>
            </div>
            <div class="produto-container">
                <div class="checkbox">
                <PCheckBox class="mr-3" :binary="true" v-model="CaracteristicasPedido.FacaMedidaEmpresa" @click="limparCampoEmpresaMedida"></PCheckBox>
                <label class="label">Produto</label>
              </div>
              </div>
              </div>
                <div v-if="CaracteristicasPedido.FacaMedidaEmpresa " class="campos-aparecem-empresa">
                  <PDropDown
                              v-model="UnidadeMedida"
                              :options="UnidadeArray"
                              optionLabel="nome"
                              optionValue="id"
                              placeholder="Selecione"
                              class="empresa"/>
                <div class="Campos-Produto">
                <div class="produto-container">
                  <label class=" label">Produto Nº</label>
                  <PDropDown
                    v-model="CaracteristicasPedido.FacaMedidaProdutoId"
                    :options="ProdutoOpcoesMedida"
                    @filter="buscarProdutosConformeProdutoMedida($event.value)"
                    @change="separaCodigoProdutoMedida"
                    optionLabel="labelProduto"
                    optionValue="produtoId"
                    placeholder="Selecione a Referência"
                    :filter="true"
                  >
                <template #option="slotProps">
                  <produto-dropdown-item :produto="slotProps.option"></produto-dropdown-item>
                </template>
              </PDropDown>
              </div>
            </div>
          </div>
            <div class="observacoes-container">
              <div class="obs-titulo">Observações</div>
              <PTextArea class="obs-campo" v-model="CaracteristicasPedido.FacaMedidaDescricao" rows="4" cols="30" ></PTextArea>
            </div>
          </div>
        </div>
        <div class="gerais-container espacamento-fluxos" v-if="EhKanban">
          <div class="titulo-grupo-detalhes">Geral</div>
            <div class="checkbox-geral" v-if="clienteProgramacao">
              <!-- <PCheckBox class="mr-3" :binary="true" id="kanbanencolhivel" value="KanbanEncolhivel" v-model="CaracteristicasPedido.ProgramacaoKanban"></PCheckBox> -->
              <label for="selo" class="label">É programação Kanban? <strong class="asterisco-obrigatorio">*</strong></label>
              <div class="kanban-container">
                <div class="kanban-sim-nao">
                  <PRadioButton
                    :value="true"
                    v-model="ProgramacaoKanban"
                    name="btnRepeticao"
                  ></PRadioButton>
                  <label class="label">Sim</label>
                </div>
                <div class="kanban-sim-nao">
                  <PRadioButton
                    :value="false"
                    v-model="ProgramacaoKanban"
                    name="btnRA"
                  ></PRadioButton>
                  <label class="label">Não</label>
                </div>
              </div>
            </div>

          </div>
          <div class="observacoes-container">
            <div class="obs-titulo">Observações Gerais do Pedido</div>
            <PTextArea class="obs-campo" v-model="CaracteristicasPedido.ObservacaoGeral" rows="4" cols="30" ></PTextArea>
          </div>
        </div>
      </g-form>


    <div class="buttons-next-back">
      <div class="button-next">
        <g-button 
        tipo="amarelo"
        altura="35px"
        largura="100%"
        negritoTexto  
        @click="finalizar"
        >
          CONTINUAR
        </g-button>
      </div>
      <div class="button-back">
        <g-button 
        tipo="cinza" 
        altura="35px"
        largura="100%"
        negritoTexto  
        @click="voltarstep3"
        >
          VOLTAR
        </g-button>
      </div>
    </div>


    <!-- popup após finalização -->
    <PDialog :showHeader="false" :closable="false" v-model:visible="popup">
      <div class="titulo-popup-finalizado"> Deseja finalizar e gerar o Pedido? </div>
      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click="fecharpopup"
          >
            NÃO 
          </g-button>
        </div>
        <div>
          <g-button  
          negritoTexto
          largura="200px" 
          altura="35px"
          @click="paginafinalizada"
          ref="botaoContinuar"
          > 
            SIM 
          </g-button>
        </div>
              </div>
    </PDialog>
  </div>
</template>

<script>
import CaracProduto from './CaracProduto.js'
export default CaracProduto
</script>

<style scoped>
.checkbox {
  display: flex;
  padding-top: 3px;
  padding-bottom: 3px;
}

.conteudo-pagina {
  padding: 0px 10px;
}

.obs-titulo {
  margin-top: 15px;
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 17px;
  font-weight: bold;
  text-align: left;
  margin-bottom: 15px;
}

.label {
  color: #8A8A8A;
  margin-bottom: 8px;
  text-align: left;
  font-size: 15px;
  font-family: 'MontSerrat';
  margin-left: 5px;
}

.titulo {
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 20px;
  font-weight: bold;
}

.titulo-grupo-detalhes {
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 20px;
  font-weight: bold;
  margin-top: 2%;
  margin-bottom: 2%;
  text-align: left;
}

.subtitulo {
  margin: 10px 10px;
  font-family: "MontSerrat";
  color: #8a8a8a;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 30px;
}

.obs-campo {
  width: 100%;
}

.campos {
  display: flex;
  gap: 5px;
}

.botaosim{
  margin-bottom: 3%;
}


@media (min-width:310px) {
  .btnAvancarVoltar {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 50px;
    row-gap: 10px;
    margin-top: 2%;
  }

  .checkbox-geral {
    display: flex;
    flex-direction: column;
  }

  .fsc-local-container {
    width: 100%;
  }

  .fsc-observacao-container {
    width: 100%;
  }

  .kanban-container {
    display: flex;
    gap: 5rem;
  }

  .kanban-sim-nao {
    display: flex;
    align-items: baseline;
    justify-content: center;
  }



}

@media (min-width:368px) {}

@media (min-width:600px) {
  .conteudo-pagina {
    padding: 0px 30px;
  }

}

@media (min-width:801px) {
  .campos-aparecem-empresa {
    display: flex;
    gap: 2%;
    align-items: flex-end;
    width: 50%;
    margin-top: 1%;
  }
}

@media (min-width:1025px) {
  .conteudo-pagina {
    padding: 0px 80px;
  }

  .containers-agrupa {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 2%;
  }

  .containers-embalagem {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 2%;
  }

  .fsc-infos-container{
    display: flex;
    justify-content: space-between;
    gap: 5rem;
  }

  .fsc-local-container {
    width: 50%;
  }

  .fsc-observacao-container {
    width: 50%;
  }
}
@media (min-width:1500px) {
  .espacamento-fluxos {
    padding: 0 10% 0px;
  }
}

@media (min-width:1800px) {
  .espacamento-fluxos {
    padding: 0 12% 0px;
  }
}

@media (min-width:2000px) {
  .espacamento-fluxos {
    padding: 0 14% 0px;
  }
}
</style>
